import { defineAction } from '~/prix'
import { z } from 'zod'
import creditProgramDeleteAction from './creditProgramDelete.action.json' with { type: 'json' }
import { creditProgramObject } from '../creditProgramObject'

const creditProgramDeleteDefinition = defineAction({
  ...creditProgramDeleteAction,

  input: z.object({ id: creditProgramObject.shape.id }),
  output: z.object({}),
})

export default creditProgramDeleteDefinition

